import React from 'react';
import { Search, Calendar, DollarSign, MapPin } from 'lucide-react';

const InquirySelector = ({ inquiries, selectedInquiry, onSelect, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
        <div className="animate-pulse space-y-4">
          <div className="h-6 bg-gray-200 rounded w-1/4"></div>
          <div className="h-24 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  if (inquiries?.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-2xl shadow-lg p-6 mb-8">
      <div className="flex items-center gap-3 mb-4">
        <Search className="w-5 h-5 text-indigo-600" />
        <h2 className="text-xl font-bold text-gray-900">Select Scout Inquiry</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {inquiries?.map((inquiry) => (
          <button
            key={inquiry?.id}
            onClick={() => onSelect(inquiry)}
            className={`text-left p-4 rounded-xl border-2 transition-all duration-200 hover:shadow-md ${
              selectedInquiry?.id === inquiry?.id
                ? 'border-indigo-600 bg-indigo-50 shadow-md'
                : 'border-gray-200 bg-white hover:border-indigo-300'
            }`}
          >
            <h3 className="font-semibold text-gray-900 mb-2 line-clamp-1">{inquiry?.title}</h3>
            
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-gray-600">
                <MapPin className="w-4 h-4 flex-shrink-0" />
                <span className="line-clamp-1">{inquiry?.positionRequired}</span>
              </div>
              
              <div className="flex items-center gap-2 text-gray-600">
                <DollarSign className="w-4 h-4 flex-shrink-0" />
                <span>
                  {inquiry?.budgetMin?.toLocaleString()} - {inquiry?.budgetMax?.toLocaleString()} {inquiry?.currency}
                </span>
              </div>
              
              {inquiry?.timelineDeadline && (
                <div className="flex items-center gap-2 text-gray-600">
                  <Calendar className="w-4 h-4 flex-shrink-0" />
                  <span>{new Date(inquiry?.timelineDeadline)?.toLocaleDateString()}</span>
                </div>
              )}
            </div>

            <div className="mt-3 pt-3 border-t border-gray-200 flex items-center justify-between text-xs text-gray-500">
              <span>{inquiry?.club?.organization || inquiry?.club?.full_name}</span>
              <span className="bg-green-100 text-green-800 px-2 py-1 rounded-full font-medium">
                {inquiry?.status}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default InquirySelector;